import { createSlice } from "@reduxjs/toolkit";


export const orderSlice = createSlice({
    name: 'orderReducers',
    initialState: {
        order: null,
        orders: null,
    },
    reducers: {

        // Buying Orders
        buyOrderListRequest: (state) => { state.buyOrderLoading = true },
        buyOrderListSuccess: (state,action) => { state.buyOrderLoading = false; state.buyOrderSuccess = true; state.orders = action.payload },
        buyOrderListFail: (state,action) => { state.buyOrderLoading = false; state.buyOrderError = action.payload },

        // Order Detail
        orderDetailRequest: (state) => { state.orderDetailLoading = true },
        orderDetailSuccess: (state,action) => { state.orderDetailLoading = false; state.orderDetailSuccess = true; state.order = action.payload },
        orderDetailFail: (state,action) => { state.orderDetailLoading = false; state.orderDetailError = action.payload },

        // Confirmed Orders
        confirmedOrderListRequest: (state) => { state.confirmedOrderLoading = true },
        confirmedOrderListSuccess: (state,action) => { state.confirmedOrderLoading = false; state.confirmedOrderSuccess = true; state.orders = action.payload },
        confirmedOrderListFail: (state,action) => { state.confirmedOrderLoading = false; state.confirmedOrderError = action.payload },

        // Update Order
        updateOrderRequest: (state) => { state.updateOrderLoading = true },
        updateOrderSuccess: (state,action) => { state.updateOrderLoading = false; state.updateOrderSuccess = true },
        updateOrderFail: (state,action) => { state.updateOrderLoading = false; state.updateOrderError = action.payload },

        // Reset
        orderReset: (state) => {
            return {
                ...state,
                // Reset all loading states
                buyOrderLoading: false,
                orderDetailLoading: false,
                confirmedOrderLoading: false,
                updateOrderLoading: false,
                
                // Reset all success states
                buyOrderSuccess: false,
                orderDetailSuccess: false,
                confirmedOrderSuccess: false,
                updateOrderSuccess: false,
                
                // Reset all error states
                buyOrderError: null,
                orderDetailError: null,
                confirmedOrderError: null,
                updateOrderError: null,
                
                // Keep the orders and order data
                orders: state.orders,
                order: state.order
            }
        }
    }
})

export const {
    buyOrderListRequest,
    buyOrderListSuccess,
    buyOrderListFail,

    orderDetailRequest,
    orderDetailSuccess,
    orderDetailFail,

    confirmedOrderListRequest,
    confirmedOrderListSuccess,
    confirmedOrderListFail,

    updateOrderRequest,
    updateOrderSuccess,
    updateOrderFail,

    orderReset,
} = orderSlice.actions

export default orderSlice.reducer
